export default "__VITE_ASSET__d4e0b795__"